import React from 'react';

interface SimulationBadgeProps {
  className?: string;
}

export const SimulationBadge: React.FC<SimulationBadgeProps> = ({ className = '' }) => (
  <span
    className={`simulation-badge${className ? ` ${className}` : ''}`}
    title="Created by the admin PDF simulator"
    style={{
      display: 'inline-block',
      padding: '2px 8px',
      border: '1px solid #cbd5e1',
      borderRadius: '999px',
      background: '#f1f5f9',
      color: '#475569',
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '0.02em',
      whiteSpace: 'nowrap',
    }}
  >
    SIMULATION
  </span>
);
